import { ApplicationCode } from "constants/auth";

import Authorization from "features/authorization/Authorization";

import { RequestList } from "../components/RequestList";

export const Request = () => {
  return (
    <Authorization permission={[ApplicationCode.Request]}>
      <RequestList />
    </Authorization>
  );
};
